<template>
	<div class="banner">
		<div class="banner-box">
			<div class="banner-title">
				<div class="banner-title-box" :style="bannerTitleBoxBg">
					<span class="banner-title-content-h1">{{BTitle}}</span>
					<span class="banner-title-content-h2">{{STitle}}</span>
					<span class="banner-title-content-link">进一步了解 ></span>
				</div>
			</div>
			<div class="banner-image">
				<div class="banner-image-box">
					<img :src="imgUrl" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'banner',
		props: [],
		data() {
			return {
				imgUrl:this.GLOBAL.imgHost + '/images/beikao.png',
				bannerTitleBoxBg:'background-image: url('+this.GLOBAL.imgHost+'/images/lf-bg.png);',
				BTitle: '乐班人体工学可调背靠',
				STitle: '科学塑形 舒适依靠'
			};
		}
	}
</script>

<style>
	.banner {
		width: 100%;
		padding-top: 5%;
		max-height: 650px;
		/* background: rgba(241, 241, 241, 1); */
		display: flex;
		flex-direction: row;
		justify-content: center;
	}

	.banner-box {
		width: 100%;
		max-width: 1024px;
		display: flex;
		flex-direction: row;
	}

	.banner-title {
		width: 50%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		position: relative;
		line-height: 50px;
	}

	.banner-title-content-h1 {
		font-size: 2rem;
		 
		font-weight: 650;
		color: rgba(24, 24, 24, 1);
		margin-bottom: 40px;
		text-indent: 1rem;
	}

	.banner-title-box {
		display: flex;
		flex-direction: column;
		text-align: left;
		background-size: 40px 40px;
		background-repeat: no-repeat;
		margin-left: 25px;
	}

	.banner-title .lf-icon {
		position: absolute;
		top: 0;
		left: 0;
	}

	.banner-image {
		width: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.banner-image-box {
		width: 90%;
		/* margin-top: 10%; */
	}

	.banner-image-box img {
		width: 100%;
		display: block;
	}

	.banner-title-content-h2 {
		font-size: 1.4rem;
		 
		font-weight: 400;
		color: rgba(24, 24, 24, 1);
		line-height: 30px;
		display: block;
		text-indent: 1rem;
	}

	.banner-title-content-link {
		font-size: 1.25rem;
		 
		font-weight: 400;
		color: rgba(0, 199, 133, 1);
		margin-top: 20%;
		text-indent: 1rem;
	}
</style>
